import Icon from '../components/Icon.vue'

Icon.register({
  'hand-lizard': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M384 480H576V363.8A96-96 0 0 1 561.2 312.5L398.1 54.4A48-48 0 0 1 357.5 32H24C10.7 32 0 42.7 0 56V72C0 102.9 25.1 128 56 128H286C298.8 128 307.5 141.1 302.6 152.9L281.2 204.3A32-32 0 0 0 251.6 224H128C92.7 224 64 252.7 64 288V296C64 309.3 74.7 320 88 320H235.4A48-48 0 0 0 261.1 327.5L372.8 398.3A24-24 0 0 0 384 418.5V480z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hand-lizard.js
// module id = xtX/
// module chunks = 144